import * as PIXI from "pixi.js";
import HowToPlayLayer from "../../layers/HowToPlayLayer";
import { EventBus, EnumEventBus } from "../../managers/EventBus";
import HTPMatchToSameInfo from "./thirdPart/HTPMatchToSameInfo";
import HTPAllSymbolsInfo from "./thirdPart/HTPAllSymbolsInfo";
import HTPInfoAboutFireworkAnimation from "../../animations/HTPInfoAboutFireworkAnimation";
import ClickAnyWhereThird from "./thirdPart/ClickAnyWhereThirdPart";
import HTPClickAnyAnimation from "../../animations/HTPClickAnyAnimation";
import resetScale from "../../helper/resetScale";


export default class HTPThirdPart extends PIXI.Container {
  static instance: HTPThirdPart;
  private HowToPlayLayer = HowToPlayLayer.getInstance();
  private EventBus = EventBus;
  private HTPMatch: HTPMatchToSameInfo;
  private HTPAllSymbols: HTPAllSymbolsInfo;
  private ClickAnyWhere: ClickAnyWhereThird;
  private isReversed: boolean = false;
  constructor() {
    super();
    if (!HTPThirdPart.instance) {
      HTPThirdPart.instance = this;
    }
    this.HTPMatch = new HTPMatchToSameInfo();
    this.HTPAllSymbols = new HTPAllSymbolsInfo();
    this.ClickAnyWhere = new ClickAnyWhereThird();
    this.addToLayer();
  }

  runAnimations() {
    this.isReversed = false;
    this.ClickAnyWhere.visible = false;
    this.ClickAnyWhere.scale.set(this.ClickAnyWhere.startScale);
    resetScale(this.HTPAllSymbols);
    resetScale(this.HTPMatch);

    this.EventBus.emit(EnumEventBus.setHFType, "4");
    this.HTPMatch.visible = true;
    new HTPInfoAboutFireworkAnimation(this.HTPMatch, 1, () => {
      if (this.isReversed) {
        return
      }
      this.HTPAllSymbols.visible = true;
      new HTPInfoAboutFireworkAnimation(this.HTPAllSymbols, 1, () => {
        if (this.isReversed) {
          return
        }
        this.ClickAnyWhere.visible = true;
        new HTPClickAnyAnimation(this.ClickAnyWhere, 1, () => {
        })
      })
    })
  }
  runReverseAnimations(cb: () => void) {
    this.isReversed = true;
    this.ClickAnyWhere.visible = false;
    resetScale(this.HTPAllSymbols);
    resetScale(this.HTPMatch);
    cb();
  }
  addToLayer() {
    this.HowToPlayLayer.addChild(this);
  }
  static getInstance() {
    return HTPThirdPart.instance;
  }
}